import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "src/app/shared/utils/jspdf-autotable";
import { generateRoadAlignedPath } from "./interpolate-points";
import * as L from "leaflet";
import { Router } from "@angular/router";
import { ApiService } from "src/app/providers/api.service";
import { animate } from "@angular/animations";
import { Location, DatePipe } from "@angular/common";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { FormGroup, FormControl, Validator, Validators } from "@angular/forms";
import moment from "moment";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { PointedShape } from "@amcharts/amcharts4/core";
import { Console } from "console";
import "leaflet-rotatedmarker";
// import { truncate } from 'fs';
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
// import * as turf from '@turf/turf';
// import { fetchSmoothRoadPath } from './osrm-route-util' preprocessAndSmoothPlaybackPoints,;
// import {  smoothRoadPath } from './preprocess-playback';
import * as turf from "@turf/turf";

@Component({
  selector: "app-play-back",
  templateUrl: "./play-back.component.html",
  styleUrls: ["./play-back.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PlayBackComponent implements OnInit {
  points: any = [];
  plypoint: any = [];
  playbackmap;
  trackVehicleSpeed: string = "--";
  trackVehicleTimestamp: string = "--";
  actualTimeDisplay: string = "--";
  // Keep last known GPS speed to use during interpolated frames
  private lastKnownSpeedCt: number | null = null;
  // Keep last positive GPS speed to avoid sticking to 0 during interpolations
  private lastPositiveSpeedCt: number | null = null;
  private lastSegmentDurationMs: number | null = null;
  init_lat = 17;
  init_lng = 81;
  checked: any = false;
  finalSpdMrkrs: any = [];
  plybckIcn;
  fencInOutDtls: any = [];
  plypoint1: any = [];
  endPBMarker;
  startPBMarker;
  slctdItm: any;
  marker;
  selectedvndr: any;
  rtplydata;
  line;
  index;
  stoppageTime;
  travelDist: string = "--";
  timerId: any;
  pauseindex;
  animate;
  shwLoc: any = [];
  isCollapsed = false;
  opnSdebar: boolean;
  trpdate: boolean;
  trpdtl: boolean;
  strtdate: boolean;
  enddate: boolean;
  plyBckform;
  lctnsDta: any = [];
  vhclsDta: any = [];
  trpDta: any = [];
  fncDtls: any = [];
  pauseVal = true; // true = playing, false = paused
  // Playback speed configuration
  speedOptions = [100, 150, 200, 250];
  speedLabels = {
    100: "1x",
    150: "1.5x",
    200: "2x",
    250: "3x",
  };
  minSpeed = 100;
  maxSpeed = 250;
  asrtiD: any;
  showLdr = false;
  sliderValue = 100; // Default to 1x speed
  speedval = 100;
  showSpeedControl = false; // Control visibility of speed controls
  showTimeline = false;
  Route_collectPointArray: any = [];
  Route_collectPointArray1: any = [];
  usrDtls;
  pbMarkerEndPosition;
  activeGroups: any = [];
  pointMarker;
  locations: any = [];
  route_Polyline: any;
  route_Polyline2: any; //array of schedule routes by selecting vehicle
  allChecked = false;
  masterSelected: boolean;
  checklist: any = [];
  checkedList: any;
  shwSpdMtr = false;
  drvr_nm: string = "--";
  drvr_mbl_nu: string = "--";
  // @ViewChild('multiSelect') multiSelect;
  public loadContent: boolean = false;
  public name = "Cricketers";
  public data = [];
  public settings = {};
  public selectedItems = [];
  _lastIndex: any = [];
  locModel: any = [];
  points1: any = [];
  date = new Date();
  sdate: Date = new Date();
  edate: Date = new Date();
  asrt_id: any;
  totalTravelTime: string = "--";
  plannedTravelTime: string = "--";
  RoutePoints: any = [];
  strtTm = this.datepipe.transform(this.date, "yyyy-MM-dd HH:mm");
  endTm = this.datepipe.transform(this.date, "yyyy-MM-dd HH:mm");
  trpdt = this.datepipe.transform(this.date, "yyyy-MM-dd");
  // zeroDt=this.datepipe.transform('0000-00-00 00:00:00', 'yyyy-MM-dd HH:mm');
  polygon: L.Polygon<any>;
  polygon1: L.Polygon<any>;
  fncepolygon: L.Polygon<any>;
  playPolygonData: any = [];
  playPolygonData1: any = [];
  // indeterminate;
  plygnLatlngs: any;
  isCheckedButton: boolean;
  lctns: any = [];
  cntxt: any = [];
  // allChecked = false;
  indeterminate = true;
  clntDtls: any = [];
  tntLst: any = [];
  seletedIndex: any;
  selectedtenants: any = [];
  vendorList: any = [];
  vehdetails: boolean;
  showVndr: boolean = false;
  clap_in: number;
  ShowClap: boolean = false;
  userDtls: any;
  slctdDfltTnt: any;
  showAll: boolean = false;
  tripData: any;
  isUrban: boolean;
  lbl: string;
  grpLbl: string;
  fncsGrpId: any;
  fncsLst: any;
  fnclocModel: any = [];
  selectedWrd: any;
  wardLst: any;
  wrdfncepolygon: L.Polygon<any>;
  wrdplypoint: any = [];
  schdRtsLst: any = [];
  vehicleDupDtls: any = [];
  assrtGroupList: any = [];
  asrt_grp_id: any;
  asrtGrps: any;
  // Remember last known bearing (degrees) to fall back when needed
  lastDirectionAngle: number = 0;
  route_PolylineSmooth: any;
  // Tracks current playback time in ms for updating timestamp during interpolation
  currentPlaybackTimeMs: number | null = null;
  private playbackStartTimeMs: number | null = null;
  private cumulativeDistanceMeters = 0;
  private lastPlottedLatLng: L.LatLng | null = null;
  fnlParkingPoints: any = [];
  // collectedParkingPoints: any= [];
  playbackCompleted: boolean = false;
  shwprkng: boolean = false;
  @ViewChild("gridContainer", { static: false }) gridContainer: any;

  constructor(
    private apiS: ApiService,
    private router: Router,
    private ref: ChangeDetectorRef,
    public datepipe: DatePipe,
    private message: NzMessageService,
    public TransfereService: TransfereService
  ) {
    this.plyBckform = new FormGroup({
      lctn: new FormControl(""),
      lctnFnce: new FormControl(""),
      vhcl: new FormControl(""),
      plybtype: new FormControl(""),
      trpdt: new FormControl(""),
      trp: new FormControl(""),
      strtTm: new FormControl(""),
      endTm: new FormControl(""),
    });

    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    console.log(this.clntDtls);
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
    if (this.tntLst[0].urban_in == 1 && this.clntDtls[0].clnt_id == 7) {
      this.isUrban = true;
      this.lbl = "ULB";
      this.grpLbl = "Vehicle Group";
    } else if (this.clntDtls[0].clnt_id == 7 && this.tntLst[0].urban_in == 0) {
      this.isUrban = false;
      this.lbl = "Mandal";
      this.grpLbl = "Panchayati";
    } else if (this.clntDtls[0].clnt_id == 3000001) {
      this.grpLbl = "Ward";
    }
    // console.log('seletedIndex --------------- ', this.seletedIndex);
    console.log(this.tntLst.length);
    if (this.tntLst.length == 1) {
      this.selectedtenants = this.tntLst[0].tnt_id;
      this.slctdDfltTnt = this.selectedtenants;
      console.log(this.selectedtenants);
      this.showAll = false;
    } else {
      this.selectedtenants = 0;
      this.slctdDfltTnt = this.selectedtenants;
      console.log(this.selectedtenants);
      this.showAll = true;
    }
    this.selectedvndr = 0;

    // this.sliderValue = 100;

    this.tripData = this.TransfereService.getLoclData("plybckDta");
    console.log(this.tripData);
    this.TransfereService.ClearLocalData("plybckDta");

    if (this.tripData) {
      this.selectedtenants = this.tripData.tnt_id;
      // this.getvehiclesFunctn(this.selectedtenants);
      this.asrt_id = this.tripData.asrt_id;
      // this.plyBckform.value.vhcl
      this.plyBckform.get("vhcl").setValue(this.tripData.asrt_id);
      // this.plyBckform.get('strtTm').setValue(this.datepipe.transform(this.tripData.actl_strt_ts, 'yyyy-dd-MM'));
      // this.plyBckform.get('endTm').setValue(this.datepipe.transform(this.tripData.actl_end_ts, 'yyyy-dd-MM'));
      this.plyBckform.get("plybtype").setValue(1);
      this.plyBckform.value.plybtype = 1;
      this.getPlybackType(1);
      this.plyBckform.get("trpdt").setValue(this.tripData.actl_strt);
      // this.date = this.plyBckform.value.trpdt;
      this.getTrpDate(this.plyBckform.value.trpdt);
      // this.plyBckform.value.strtTm = this.datepipe.transform(this.tripData.actl_strt_ts, 'yyyy-dd-MM HH:mm');
      // this.plyBckform.value.endTm = this.datepipe.transform(this.tripData.actl_end_ts, 'yyyy-dd-MM HH:mm');
      // // this.getTrpDate(this.date)
    }
    console.log(this.date);
  }

  getvehiclesFunctn(value) {
    if (value == 0) {
      this.playbackmap.setView([15.912327, 79.739238], 7);
    } else {
      for (var i = 0; i < this.tntLst.length; i++) {
        if (this.tntLst[i].tnt_id == value) {
          if (this.tntLst[i].lat && this.tntLst[i].lng) {
            this.playbackmap.setView(
              [this.tntLst[i].lat, this.tntLst[i].lng],
              13
            );
          } else {
            this.playbackmap.setView([15.912327, 79.739238], 7);
          }
        }
      }
    }
    /************Get Current Vehicles List************************* */
    this.getVhcles();

    this.getVendors();
    // this.apiS.get(`billing/vehicle-wise/vendors/list/${this.selectedtenants}`).subscribe((res) => {
    //   console.log(res)
    //   if (res['status'] == 200) {
    //     this.vendorList = res['data'];
    //   }
    // }, (err) => {
    //   console.log("In errorr");
    // })
    this.apiS.get(`playback/vehicle/groups/${this.selectedtenants}`).subscribe(
      (res) => {
        console.log(res);
        if (res["status"] == 200) {
          this.assrtGroupList = res["data"];
        }
      },
      (err) => {
        console.log("In errorr");
      }
    );

    this.apiS.get(`playback/landmark/groups/${this.selectedtenants}`).subscribe(
      (res) => {
        console.log(res["data"]);
        this.activeGroups = res["data"];
        // for (var m = 0; m < this.activeGroups.length; m++) {
        //   this.lctnsDta.push({
        //     'id': this.activeGroups[m].fnce_grp_id,
        //     'name': this.activeGroups[m].fnce_grp_nm
        //   })
        // }
        console.log(this.activeGroups);
        // this.updt();
      },
      (err) => {
        console.log("In errorr");
      }
    );

    this.apiS.get("playback/location/points").subscribe(
      (res) => {
        this.points1 = res["data"];
        console.log(this.points1);
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }
  getVhcles() {
    this.apiS
      .get(
        `playback/web/vehicles/cur_Running/${this.selectedtenants}/${this.selectedvndr}`
      )
      .subscribe(
        (res) => {
          console.log(res);
          this.vehicleDupDtls = res["data"];
          this.vhclsDta = [];
          console.log(this.vehicleDupDtls, this.asrt_grp_id);
          if (this.asrt_grp_id > 0) {
            this.vhclsDta = this.vehicleDupDtls.filter(
              (vhclsDta) => vhclsDta.asrt_grp_id == this.asrt_grp_id
            );
          } else {
            this.vhclsDta = this.vehicleDupDtls;
          }
        },
        (err) => {
          console.log("In errorr");
        }
      );
  }
  getVendors() {
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      this.apiS.get(`billing/vendors/list/${this.selectedvndr}/byId`).subscribe(
        (res) => {
          console.log(res);
          if (res["status"] == 200) {
            this.vendorList = res["data"];
          }
        },
        (err) => {
          console.log("In errorr");
        }
      );
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
    } else {
      this.apiS
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenants}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              // this.USER_PERMISSIONS = res['perm'][0];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
              }
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    }
  }
  onvndrSelect(value) {
    if (value == 0) {
      this.selectedvndr = 0;
    } else if (value == 1) {
      // this.tntLst = [];
    } else {
      this.selectedvndr = value;
    }
    this.getVhcles();
  }
  getTripsbyAsrt(asrt_id) {
    console.log(asrt_id);
    this.clearMarkersonMap();
    this.handleVehicleChangeCleanup();

    if (!asrt_id) {
      this.asrt_id = null;
      return;
    }

    if (this.plypoint) {
      for (var k = 0; k < this.plypoint.length; k++) {
        this.playbackmap.removeLayer(this.plypoint[k].ply);
      }
    }

    this.asrt_id = asrt_id;
    // console.log(this.asrtiD);
    // /************Get TripsList By Asrt_id List************************* */
    // var preDtaObj = {

    //   "trpdate":this.datepipe.transform(this.plyBckform.value.trpdt, 'yyyy-MM-dd'),
    //   // "sdate": this.datepipe.transform(this.sdate, 'yyyy-MM-dd 00:00'),
    //   // "edate": this.datepipe.transform(this.edate, 'yyyy-MM-dd 23:59'),
    //   "asrt_id": this.asrt_id
    // };
    // console.log(preDtaObj)
    // this.apiS.post(preDtaObj, 'playback/vehicle/trips').subscribe((res) => {
    //   console.log(res['data']);
    //   this.trpDta = res['data'];
    // }, (err) => {
    //   console.log("In errorr");
    // })
    console.log(this.clntDtls[0].clnt_id);
    if (this.clntDtls[0].clnt_id != 7) {
      this.getWrdbyAsrt();
    }
    this.removeAllSchedPlyline();
    if (this.clntDtls[0].clnt_id == 3000001) {
      this.getscheduledRoutes();
    }
  }
  getWrdbyAsrt() {
    this.removeAllSchedPlyline();
    if (this.wrdplypoint) {
      for (var k = 0; k < this.wrdplypoint.length; k++) {
        this.playbackmap.removeLayer(this.wrdplypoint[k].ply);
      }
    }
    this.apiS.get(`playback/wards/byVhcle/${this.asrt_id}`).subscribe(
      (res) => {
        if (res["status"] === 200) {
          this.wardLst = res["data"];
          for (var l = 0; l < this.wardLst.length; l++)
            if (this.wardLst[l].fnce_arc_lne_tx) {
              this.wrdfncepolygon = L.polygon(
                JSON.parse(this.wardLst[l].fnce_arc_lne_tx) as [],
                { color: this.wardLst[l].fncs_clr_cd }
              )
                .addTo(this.playbackmap)
                .bindTooltip(this.wardLst[l].wrd_nm, {
                  permanent: true,
                  opacity: 0.7,
                })
                .openTooltip();
              this.wrdplypoint.push({
                ply: this.wrdfncepolygon,
                fnce_id: this.wardLst[l].fnce_id,
              });
              this.playbackmap.fitBounds(this.wrdfncepolygon.getBounds());
            }
        }
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }
  getTrpDate(dt) {
    console.log(this.plyBckform.value.vhcl);
    console.log(dt);
    /************Get TripsList By Asrt_id List************************* */
    var preDtaObj = {
      trpdate: this.datepipe.transform(dt, "yyyy-MM-dd"),
      // "sdate": this.datepipe.transform(this.sdate, 'yyyy-MM-dd 00:00'),
      // "edate": this.datepipe.transform(this.edate, 'yyyy-MM-dd 23:59'),
      asrt_id: this.plyBckform.value.vhcl,
    };
    console.log(preDtaObj);
    this.apiS.post(preDtaObj, "playback/vehicle/trips").subscribe(
      (res) => {
        console.log("resssssssssssssssssssssssssssssssss", res["data"]);
        this.trpDta = res["data"];
        if (this.tripData && this.tripData.trp_rn_id) {
          this.plyBckform.get("trp").setValue(this.tripData.trp_rn_id);
          this.getTripData(this.tripData.trp_rn_id);
        }
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }
  onLocationSelect(evt) {
    this.fncsGrpId = evt;
    this.fncsByGrp(this.fncsGrpId);
  }
  fncsByGrp(grp_id) {
    this.apiS.get(`playback/landmark/bygroups/${grp_id}`).subscribe(
      (res) => {
        console.log(res);
        this.fncsLst = res["data"];
        console.log(this.fncsLst);
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }
  getLocOnMap() {
    this.locations = [];

    if (this.pointMarker) {
      for (var k = 0; k < this._lastIndex.length; k++) {
        this.playbackmap.removeLayer(this._lastIndex[k]);
      }
    }

    if (this.plypoint1) {
      for (var k = 0; k < this.plypoint1.length; k++) {
        this.playbackmap.removeLayer(this.plypoint1[k].ply);
      }
    }
    if (this.fnclocModel) {
      if (this.fnclocModel == "select") {
        for (var j = 0; j < this.fncsLst.length; j++) {
          for (var k = 0; k < this.points1.length; k++) {
            if (this.fncsLst[j].fnce_grp_id == this.points1[k].fnce_grp_id) {
              console.log(
                this.fncsLst[j].fnce_grp_id == this.points1[k].fnce_grp_id
              );

              this.locations.push(this.points1[k]);
            }
          }
        }
      } else if (this.fnclocModel == "deselect") {
        this.locations = [];
      } else {
        if (this.fncsLst && this.fncsLst.length > 0) {
          for (var j = 0; j < this.fncsLst.length; j++) {
            if (this.fnclocModel == this.fncsLst[j].fnce_id) {
              for (var k = 0; k < this.points1.length; k++) {
                if (this.fncsLst[j].fnce_id == this.points1[k].fnce_id) {
                  console.log(
                    this.fncsLst[j].fnce_id == this.points1[k].fnce_id
                  );

                  this.locations.push(this.points1[k]);
                }
              }
            }
          }
        }
      }
      for (var l = 0; l < this.locations.length; l++) {
        // console.log("In location1");

        if (!this.locations[l].fncs_icn_pth) {
          // console.log("In location2");

          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/fenceIcon.png",
            iconSize: [32, 30],
            iconAnchor: [10, 39],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
          });
        } else if (this.locations[l].fncs_icn_pth == "dumperBin") {
          // console.log("In location3");

          if (this.locations[l].covr_status == 1) {
            // console.log("In location4");
            var icn = "_r_m";
          } else {
            // console.log("In location5");

            var icn = "_o_m";
          }
          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
              this.locations[l].fncs_icn_pth +
              icn +
              ".png",
            iconSize: [32, 30],
            iconAnchor: [22, 45],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
          });
        } else {
          // console.log("In location6");

          if (this.locations[l].covr_status == 1) {
            // console.log("In location7");

            var icn = "_r_m";
          } else {
            // console.log("In location8");

            var icn = "_o_m";
          }
          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
              this.locations[l].fncs_icn_pth +
              icn +
              ".png",
            // iconSize: [32, 30],
            // // iconAnchor: [22, 45],
            // iconAnchor: [16, 28],
            // // popupAnchor: [1, -34],
            // shadowSize: [41, 41]
            iconSize: [33, 33],
            iconAnchor: [16, 28],
          });
        }

        if (this.locations[l].lat && this.locations[l].lng) {
          this.pointMarker = L.marker(
            [this.locations[l].lat, this.locations[l].lng],
            {
              draggable: false, // Make the icon dragable
              // title: this.locations[l].fnce_nm, // Add a title
              opacity: 5,
              icon: thisIcon,
            }
          )
            .addTo(this.playbackmap)
            .bindTooltip(this.locations[l].fnce_nm, {
              permanent: true,
              opacity: 0.7,
              offset: [0, -20],
            })
            .openTooltip();

          var circleMarker = L.circle(
            [this.locations[l].lat, this.locations[l].lng],
            { radius: this.locations[l].rds_ct },
            {
              // stroke: false,
              // fillColor: '#f55555',
              // fillOpacity: 0.07,
            }
          ).addTo(this.playbackmap);
          circleMarker.setStyle({
            fillColor: "#f55555",
            stroke: false,
            fillOpacity: 0.07,
          });
          this._lastIndex.push(this.pointMarker);
          this._lastIndex.push(circleMarker);
          if (this.locations[l].fnce_arc_lne_tx) {
            this.fncepolygon = L.polygon(
              JSON.parse(this.locations[l].fnce_arc_lne_tx) as [],
              { color: this.locations[l].fncs_clr_cd }
            )
              .addTo(this.playbackmap)
              .bindTooltip(this.locations[l].fnce_nm, {
                permanent: true,
                opacity: 0.7,
              })
              .openTooltip();
            this.plypoint1.push({
              ply: this.fncepolygon,
              fnce_id: this.locations[l].fnce_id,
            });
            this.playbackmap.fitBounds(this.fncepolygon.getBounds());
          }
        }
      }
    }
  }
  updt() {
    // this.locModel=locModel;
    console.log(this.locModel); // mcg.clearLayers();
    this.locations = [];
    if (this.pointMarker) {
      for (var k = 0; k < this._lastIndex.length; k++) {
        this.playbackmap.removeLayer(this._lastIndex[k]);
      }
    }

    if (this.plypoint1) {
      for (var k = 0; k < this.plypoint1.length; k++) {
        this.playbackmap.removeLayer(this.plypoint1[k].ply);
      }
    }
    if (this.locModel) {
      //   this.locModel.map((val) => {
      if (this.locModel == "select") {
        for (var j = 0; j < this.activeGroups.length; j++) {
          for (var k = 0; k < this.points1.length; k++) {
            if (
              this.activeGroups[j].fnce_grp_id == this.points1[k].fnce_grp_id
            ) {
              console.log(
                this.activeGroups[j].fnce_grp_id == this.points1[k].fnce_grp_id
              );

              this.locations.push(this.points1[k]);
            }
          }
        }
      } else if (this.locModel == "deselect") {
        this.locations = [];
      } else {
        for (var j = 0; j < this.activeGroups.length; j++) {
          if (this.locModel == this.activeGroups[j].fnce_grp_id) {
            // console.log("In iff2");
            // console.log(this.locModel[i], this.activeGroups[j].fnce_grp_id);

            for (var k = 0; k < this.points1.length; k++) {
              if (
                this.activeGroups[j].fnce_grp_id == this.points1[k].fnce_grp_id
              ) {
                console.log(
                  this.activeGroups[j].fnce_grp_id ==
                    this.points1[k].fnce_grp_id
                );

                this.locations.push(this.points1[k]);
              }
            }
          }
        }
      }
      // }
      // console.log(this.locations);

      for (var l = 0; l < this.locations.length; l++) {
        // console.log("In location1");

        if (!this.locations[l].fncs_icn_pth) {
          // console.log("In location2");

          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/fenceIcon.png",
            iconSize: [32, 30],
            iconAnchor: [10, 39],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
          });
        } else if (this.locations[l].fncs_icn_pth == "dumperBin") {
          // console.log("In location3");

          if (this.locations[l].covr_status == 1) {
            // console.log("In location4");
            var icn = "_r_m";
          } else {
            // console.log("In location5");

            var icn = "_o_m";
          }
          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
              this.locations[l].fncs_icn_pth +
              icn +
              ".png",
            iconSize: [32, 30],
            iconAnchor: [22, 45],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
          });
        } else {
          // console.log("In location6");

          if (this.locations[l].covr_status == 1) {
            // console.log("In location7");

            var icn = "_r_m";
          } else {
            // console.log("In location8");

            var icn = "_o_m";
          }
          var thisIcon = new L.Icon({
            iconUrl:
              "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
              this.locations[l].fncs_icn_pth +
              icn +
              ".png",
            // iconSize: [32, 30],
            // // iconAnchor: [22, 45],
            // iconAnchor: [16, 28],
            // // popupAnchor: [1, -34],
            // shadowSize: [41, 41]
            iconSize: [33, 33],
            iconAnchor: [16, 28],
          });
        }

        if (this.locations[l].lat && this.locations[l].lng) {
          this.pointMarker = L.marker(
            [this.locations[l].lat, this.locations[l].lng],
            {
              draggable: false, // Make the icon dragable
              // title: this.locations[l].fnce_nm, // Add a title
              opacity: 5,
              icon: thisIcon,
            }
          )
            .addTo(this.playbackmap)
            .bindTooltip(this.locations[l].fnce_nm, {
              permanent: true,
              opacity: 0.7,
              offset: [0, -20],
            })
            .openTooltip();

          var circleMarker = L.circle(
            [this.locations[l].lat, this.locations[l].lng],
            this.locations[l].rds_ct * 10,
            {
              stroke: false,
              fillColor: "#f55",
              fillOpacity: 0.07,
            }
          ).addTo(this.playbackmap);
          this._lastIndex.push(this.pointMarker);
          this._lastIndex.push(circleMarker);
          if (this.locations[l].fnce_arc_lne_tx) {
            this.fncepolygon = L.polygon(
              JSON.parse(this.locations[l].fnce_arc_lne_tx) as [],
              { color: this.locations[l].fncs_clr_cd }
            )
              .addTo(this.playbackmap)
              .bindTooltip(this.locations[l].fnce_nm, {
                permanent: true,
                opacity: 0.7,
              })
              .openTooltip();
            this.plypoint1.push({
              ply: this.fncepolygon,
              fnce_id: this.locations[l].fnce_id,
            });
            this.playbackmap.fitBounds(this.fncepolygon.getBounds());
          }
        }
      }
    }
  }
  closeSidebar() {
    this.isCollapsed = true;
    this.opnSdebar = false;
    this.playbackmap.invalidateSize();
  }
  openSidebar() {
    this.isCollapsed = false;
    this.opnSdebar = true;
    this.playbackmap.invalidateSize();
  }
  initialize = function () {
    this.usrDtls = JSON.parse(localStorage.getItem("wto_clients"));
    console.log(this.usrDtls);
    //----------Map Initialization (Default openstreetmap  Layer) -- Leaflet OS Playback----------//
    try {
      this.playbackmap = L.map("playbackmap", {
        center: [this.usrDtls[0].lat, this.usrDtls[0].lng],
        zoom: 3,
      });

      // const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   maxZoom: 18,
      //   minZoom: 3,
      //   attribution: ''
      // });
      const tiles = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution: "",
        }
      );

      tiles.addTo(this.playbackmap);
      this.playbackmap.setView([this.usrDtls[0].lat, this.usrDtls[0].lng], 15);

      const provider = new OpenStreetMapProvider();

      let searchControl = GeoSearchControl({
        provider: provider,
        // style: 'bar', // optional: bar|button  - default button
        showMarker: false, // optional: true|false  - default true
        showPopup: false, // optional: true|false  - default false
        popupFormat: ({ query, result }) => result.label, // optional: function    - default returns result label,
        resultFormat: ({ result }) => result.label,
        retainZoomLevel: false, // optional: true|false  - default false
        animateZoom: true, // optional: true|false  - default true
        autoClose: false, // optional: true|false  - default false
        searchLabel: "Enter address", // optional: string      - default 'Enter address'
        keepResult: false, // optional: true|false  - default false
        updateMap: true, // optional: true|false  - default true
      });
      this.playbackmap.addControl(searchControl);
    } catch (e) {
      console.log("please check map Initialization of leaflet:" + e);
    }
  };

  ngOnInit() {
    this.initialize();
    this.opnSdebar = true;
    if (this.slctdDfltTnt) {
      this.getvehiclesFunctn(this.slctdDfltTnt);
    }
  }

  //----------Pause Button -- Leaflet OS Playback----------//

  pause() {
    if (!this.pauseVal) {
      return;
    }
    this.pauseVal = false;
    this.pauseindex = this.index;
    this.resetSpeedControlsToDefault();
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }
  play() {
    if (this.pauseVal) {
      return;
    }
    this.pauseVal = true;
    this.index = this.pauseindex;
    this.timerId = this.update();
  }

  trackVehicle = function () {
    console.log(this.plyBckform.value.strtTm);
    console.log(this.plyBckform.value.endTm);
    this.showSpeedControl = true; // Show speed controls after track is clicked
    this.playbackCompleted = false;
    this.pauseVal = true;
    this.primePlaybackRuntimeMetrics();

    // Need to update the code
    var srtrt_time = this.datepipe.transform(
      this.plyBckform.value.strtTm,
      "yyyy-MM-dd"
    );
    console.log(srtrt_time);
    var startDate = new Date(srtrt_time);
    var currentDate = new Date();
    var timeDifference = currentDate.getTime() - startDate.getTime();
    var timeDifferenceInDays = timeDifference / (1000 * 60 * 60 * 24);
    console.log(typeof timeDifferenceInDays);
    this.fnlParkingPoints = [];
    if (timeDifferenceInDays < 90) {
      console.log("In trackkkkkkk");
      this.shwSpdMtr = true;
      this.clearMarkersonMap();
      //   if (this.pauseVal == true) {
      //     this.pauseVal = false;
      //     this.timerId = this.update();
      // }
      // console.log(this.rtplydata.slice(1,-1));
      if (this.rtplydata != null) {
        this.route_Polyline = L.polyline(JSON.parse(this.rtplydata), {
          color: "#008000",
          weight: 5,
          lineCap: "butt",
          opacity: 0.5,
          smoothFactor: 10.0,
          lineJoin: "round",
        }).addTo(this.playbackmap);
      }

      if (this.plyBckform.value.trp == undefined) {
        this.trp_rn_id = 0;
      } else {
        this.trp_rn_id = this.plyBckform.value.trp;
      }
      console.log(this.plyBckform);
      this.showLdr = true;
      // console.log(this.zeroDt)
      if (
        this.plyBckform.value.strtTm != undefined &&
        this.plyBckform.value.strtTm.toString() != "0000-00-00 00:00" &&
        this.plyBckform.value.strtTm != null &&
        this.plyBckform.value.strtTm != "" &&
        this.plyBckform.value.endTm != undefined &&
        this.plyBckform.value.endTm.toString() != "0000-00-00 00:00" &&
        this.plyBckform.value.endTm != null &&
        this.plyBckform.value.endTm != ""
      ) {
        var data = {
          checkbit: "byVeh",
          sdate: this.datepipe.transform(
            this.plyBckform.value.strtTm,
            "yyyy-MM-dd HH:mm"
          ),
          edate: this.datepipe.transform(
            this.plyBckform.value.endTm,
            "yyyy-MM-dd HH:mm"
          ),
          asrt_id: this.asrt_id,
          trp_rn_id: this.trp_rn_id,
        };
        console.log(data);
        // $http.post($rootScope.BaseUrl + "/vehicle/playback", data)
        this.apiS.post(data, "playback/vehicle/playback").subscribe(
          (res) => {
            // console.log(res);
            this.showLdr = false;
            // if (res && res['status'] == 200) {
            // console.log(res['data']);

            // .success(function(resdata, status) {

            var playData = res["data"];
            console.log(playData);
            //         // console.log(playData.mapPoints[0].icon_path);
            // this.plybckIcn = 'https://unpkg.com/leaflet@1.0.3/dist/images/marker-icon.png';
            // if (playData.length == 0) {
            //     // this.showTimeline=false;
            // } else {
            //     // this.showTimeline = true;
            // }
            // if(playData.fncDtls == undefined){
            //   this.showTimeline=false;
            // }else{
            //   this.showTimeline=true;

            // }
            console.log(playData.fncDtls);
            if (playData.fncDtls) {
              for (var i = 0; i < playData.fncDtls.length; i++) {
                this.fencInOutDtls.push({
                  SNo: playData.fncDtls[i].SNo,
                  fnce_id: playData.fncDtls[i].fnce_id,
                  fnce_nm: playData.fncDtls[i].fnce_nm,
                  fnc_in: playData.fncDtls[i].actl_arvl_ts,
                  fnc_ut: playData.fncDtls[i].actl_dprte_ts,
                  // asrt_nm: playData.fncDtls[i].asrt_nm,
                  fnce_cvr_sts: playData.fncDtls[i].fnce_cvr_sts,
                  stoppage: playData.fncDtls[i].stoppage,
                  lati: playData.fncDtls[i].lat,
                  longi: playData.fncDtls[i].lng,
                  icn: playData.fncDtls[i].fncs_icn_pth,
                  cvr_sts: playData.fncDtls[i].cvr_sts,
                });

                if (this.fencInOutDtls.length == 0) {
                  this.showTimeline = false;
                } else {
                  this.showTimeline = true;
                }

                if (playData.fncDtls[i].fnce_cvr_sts == 1) {
                  var thisIcon = new L.Icon({
                    iconUrl:
                      "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
                      playData.fncDtls[i].fncs_icn_pth +
                      "_r_m.png",
                    iconSize: [32, 30],
                    iconAnchor: [22, 45],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41],
                  });

                  this.RoutecollectPointMarker = L.marker(
                    [playData.fncDtls[i].lat, playData.fncDtls[i].lng],
                    {
                      draggable: false, // Make the icon dragable
                      title: playData.fncDtls[i].fnce_nm, // Add a title
                      opacity: 5,
                      icon: thisIcon,
                    }
                  )
                    .addTo(this.playbackmap)
                    .bindPopup(
                      "<div style='color: #000;'><b style='line-height: 21px; color: #1a56a2;'>Fence Name:  </b>" +
                        playData.fncDtls[i].fnce_nm +
                        "</div>"
                    )
                    .closePopup();
                  this.RoutecollectPointCircle = L.circle(
                    [playData.fncDtls[i].lat, playData.fncDtls[i].lng],
                    50,
                    {
                      stroke: false,
                      fillColor: "#ffde00",
                      fillOpacity: 0.5,
                    }
                  );
                  this.Route_collectPointArray.push(
                    this.RoutecollectPointMarker,
                    this.RoutecollectPointCircle
                  );
                }
                if (playData.fncDtls[i].fnce_cvr_sts == 0) {
                  var thisIcon = new L.Icon({
                    iconUrl:
                      "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
                      playData.fncDtls[i].fncs_icn_pth +
                      "_o_m.png",
                    iconSize: [32, 30],
                    iconAnchor: [22, 45],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41],
                  });
                  this.RoutecollectPointMarker1 = L.marker(
                    [playData.fncDtls[i].lat, playData.fncDtls[i].lng],
                    {
                      draggable: false, // Make the icon dragable
                      title: playData.fncDtls[i].fnce_nm, // Add a title
                      opacity: 5,
                      icon: thisIcon,
                    }
                  )
                    .addTo(this.playbackmap)
                    .bindPopup(
                      "<div style='color: #000;'><b style='line-height: 21px; color: #1a56a2;'>Fence Name:  </b>" +
                        playData.fncDtls[i].fnce_nm +
                        "</div>"
                    )
                    .closePopup();
                  this.RoutecollectPointCircle1 = L.circle(
                    [playData.fncDtls[i].lat, playData.fncDtls[i].lng],
                    50,
                    {
                      stroke: false,
                      fillColor: "#ffde00",
                      fillOpacity: 0.5,
                    }
                  );
                  this.Route_collectPointArray1.push(
                    this.RoutecollectPointMarker1,
                    this.RoutecollectPointCircle1
                  );
                }
              }
            }
            // console.log(playData);
            if (playData !== "" && playData.lat.length > 0) {
              console.log("InnnnplayData");
              // To avoid duplicates for start & end points
              // this.points.push({
              //   lat: playData.lat[0],
              //   lng: playData.lng[0],
              //   speed_ct: playData.mapPoints[0].speed_ct,
              //   Signal: playData.mapPoints[0].Signall,
              //   asrt_nm: playData.mapPoints[0].asrt_nm,
              //   drcn_ct: playData.mapPoints[0].drcn_ct,
              // });
              var strt = playData.mapPoints[0].Signall;
              var end =
                playData.mapPoints[playData.mapPoints.length - 1].Signall;
              this.plannedTravelTime = moment
                .utc(
                  moment(end, "DD-MM-YYYY HH:mm").diff(
                    moment(strt, "DD-MM-YYYY HH:mm")
                  )
                )
                .format("HH:mm:ss");

              // Resolve selected vehicle name from current selection
              const selV = Array.isArray(this.vhclsDta)
                ? this.vhclsDta.find(
                    (v) => String(v.asrt_id) == String(this.asrt_id)
                  )
                : null;
              const selectedAsrtNm = selV && selV.asrt_nm ? selV.asrt_nm : "";

              for (var c = 0; c < playData.lat.length; c++) {
                console.log(playData.mapPoints[c].speed_ct);
                // console.log(playData.lat[c],playData.lat[playData.lat.length - 1])
                if (
                  playData.lat[c] != playData.lat[0] &&
                  playData.lng[c] != playData.lng[0]
                ) {
                  // if (playData.lat[c] != playData.lat[playData.lat.length - 1] && playData.lng[c] != playData.lng[playData.lat.length - 1]) {
                  this.points.push({
                    lat: playData.lat[c],
                    lng: playData.lng[c],
                    speed_ct: Number(playData.mapPoints[c].speed_ct),
                    Signal: playData.mapPoints[c].Signall,
                    asrt_nm: selectedAsrtNm,
                    drcn_ct: playData.mapPoints[c].drcn_ct,
                  });
                  // }
                }
              }
              this.points.push({
                lat: playData.lat[playData.lat.length - 1],
                lng: playData.lng[playData.lat.length - 1],
                // speed_ct: Number(playData.mapPoints[playData.lat.length - 1]?.speed_ct ?? 0),
                Signal:
                  playData.mapPoints[playData.lat.length - 1].Signall !=
                  undefined
                    ? playData.mapPoints[playData.lat.length - 1].Signall
                    : "",
                asrt_nm: selectedAsrtNm,
                // drcn_ct: playData.mapPoints[playData.lat.length - 1].drcn_ct,
              });
              var trvlDstnce =
                playData.mapPoints[playData.mapPoints.length - 1].odmtr_ct -
                playData.mapPoints[0].odmtr_ct;
              var totDtnce = Math.ceil(trvlDstnce);
              this.travelDist = totDtnce + " " + "Kms";
              this.trackVehicleSpeed =
                playData.mapPoints[playData.mapPoints.length - 1].speed_ct +
                " " +
                "Kms";
              this.actualTimeDisplay =
                playData.mapPoints[playData.mapPoints.length - 1].Signall;
              var stoppageCounter = 0;
              var stoppageStartTimeIndex = 0;
              // var stoppageTime = 0;
              var diffTime;
              var pstrt;
              var pend;
              var sno = 0;
              console.log(this.points);
              for (var m = 0; m < this.points.length; m++) {
                var startTime;
                var endTime;

                if (this.points[m].speed_ct == 0) {
                  console.log("In speed");

                  // if (this.points[m].lat == this.points[m + 1].lat &&
                  //   this.points[m].lng == this.points[m + 1].lng) {
                  //     // console.log("In lattttt")
                  //   if (stoppageStartTimeIndex === 0) {
                  //     stoppageStartTimeIndex = m;
                  //     stoppageCounter = m;
                  //   } else {
                  //     stoppageCounter++;
                  //   }
                  // } else {
                  // console.log("In else");
                  // console.log(this.points[stoppageStartTimeIndex].Signal);
                  // console.log(this.points[stoppageCounter].Signal);

                  // **************************** commented bcz of not getting playback due to datepipe error***********//
                  // startTime = this.points[stoppageStartTimeIndex].Signal;
                  // endTime = this.points[stoppageCounter].Signal;
                  // console.log(this.points[m].Signal);
                  if (this.points[m].Signal == undefined) {
                    // startTime = new Date(this.points[m + 1].Signal);
                    // startTime = new Date(this.datepipe.transform(this.points[m+1].Signal, "dd.MM.yyyy HH:mm"));
                    pstrt = this.points[m + 1].Signal;
                  } else {
                    // startTime = new Date(this.points[m + 1].Signal);
                    pstrt = this.points[m].Signal;

                    // startTime = new Date(this.datepipe.transform(this.points[m].Signal, "dd.MM.yyyy HH:mm"));
                  }
                  // endTime = new Date(this.points[m + 1].Signal);

                  pend = this.points[m + 1].Signal;

                  this.stoppageTime = moment(pend, "DD-MM-YYYY HH:mm").diff(
                    moment(pstrt, "DD-MM-YYYY HH:mm")
                  );

                  // endTime = new Date(this.datepipe.transform(this.points[m+1].Signal, "dd.MM.yyyy HH:mm"));

                  // startTime=moment(this.points[stoppageStartTimeIndex].Signal).format('dd.MM.yyyy HH:mm');
                  // endTime=moment(this.points[stoppageCounter].Signal).format('dd.MM.yyyy HH:mm')

                  // console.log(this.points[m].Signal);
                  // console.log(endTime);
                  // console.log(endTime - startTime);
                  // diffTime = Math.abs(endTime - startTime);
                  // stoppageTime = Math.ceil(diffTime / 60000);
                  // stoppageTime = ( this.points[stoppageCounter].Signal-this.points[stoppageStartTimeIndex].Signal) / 60000;
                  // console.log(pend);
                  // console.log(pstrt);

                  // console.log(this.stoppageTime);
                  this.points[m]["stoppageTime"] = this.stoppageTime / 60000;
                  this.points[m]["lastTime"] = this.points[m + 1].Signal;
                  // console.log(this.stoppageTime)
                  if (this.stoppageTime != 0) {
                    this.points[m]["Sno"] = ++sno;
                  }
                  // }else{
                  //   this.points[m]["stoppageTime"] = 0;
                  //   this.points[m]["lastTime"] = this.points[m + 1].Signal;
                }
              }

              // Smooth only the moving segments while preserving parking points
              this.points = this.smoothPlaybackPoints(this.points);

              for (var k in this.points) {
              }

              var endIcon = new L.Icon({
                iconUrl: "/assets/images/markers/playback/endPoint.png",
                iconSize: [42, 45],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41],
              });

              this.endPBMarker = L.marker(
                [this.points[k].lat, this.points[k].lng],
                {
                  icon: endIcon,
                }
              ).addTo(this.playbackmap);
              this.endPBMarker
                .bindPopup(
                  "<b>Vehicle No : " +
                    this.points[k].asrt_nm +
                    "<br>Ending Time : " +
                    this.points[k].Signal +
                    "</b>"
                )
                .addTo(this.playbackmap);

              var startIcon = new L.Icon({
                iconUrl: "/assets/images/markers/playback/startPoint.png",
                iconSize: [42, 45],
                iconAnchor: [22, 45],
                popupAnchor: [1, -34],
                shadowSize: [41, 41],
              });
              console.log(this.points[0]);

              this.startPBMarker = L.marker(
                [this.points[0].lat, this.points[0].lng],
                {
                  icon: startIcon,
                }
              ).addTo(this.playbackmap);
              this.startPBMarker
                .bindPopup(
                  "<b>Vehicle No : " +
                    this.points[0].asrt_nm +
                    "<br>Starting Time : " +
                    this.points[0].Signal +
                    "</b>"
                )
                .addTo(this.playbackmap);
              // this.playbackmap.fitBounds(this.startPBMarker.getBounds());

              //             /*you can place either below "class name" or style options in polyline decoratr --- Leaflet Playback
              //             { className: 'my_polyline' }
              //             */
              // Draw the complete route polyline first to show the entire path
              const routePoints = this.points.map((point) => [
                point.lat,
                point.lng,
              ]);
              // this.route_Polyline = L.polyline(routePoints, {
              //   color: '#0088cc',
              //   weight: 2,
              //   opacity: 0.4,
              //   // dashArray: '5, 5',
              //   smoothFactor: 2.5 // Increased smoothness for better appearance
              // }).addTo(this.playbackmap);

              // Create the animation polyline for the actual vehicle movement
              this.marker = null;
              this.line = L.polyline([], {
                color: "blue",
                weight: 4,
                opacity: 0.8,
                smoothFactor: 2.0, // Increased smoothness for better animation
                lineJoin: "round",
                lineCap: "round",
                className: "playback-line",
              })
                .on("mouseover", function (e) {
                  e.target.setStyle({
                    color: "blue",
                    weight: 4,
                  });
                })
                .on("mouseout", function (e) {
                  e.target.setStyle({
                    color: "blue",
                    weight: 3,
                  });
                })
                .addTo(this.playbackmap);
              this.index = 0;
              // Block any plotting of raw points here
              // Process and plot only the smooth/interpolated points
              // this.showLdr = true;
              // const pointsCopy = [...this.points];

              // // Store original points for reference
              // this.originalPoints = [...pointsCopy];

              // smoothRoadPath(pointsCopy).then(processedPoints => {
              //   if (!processedPoints || processedPoints.length === 0) {
              //     console.warn('No points after processing');
              //     this.showLdr = false;
              //     return;
              //   }

              //   // Store the processed points
              //   this.points = processedPoints;
              //   this.RoutePoints = processedPoints;

              //   // Create or update the polyline
              //   if (this.line) {
              //     this.line.setLatLngs(processedPoints);
              //   } else {
              //     this.line = L.polyline(processedPoints, {
              //       color: '#3388ff',
              //       weight: 5,
              //       lineJoin: 'round',
              //       smoothFactor: 1,
              //       opacity: 0.8
              //     }).addTo(this.playbackmap);
              //   }

              //   // Fit bounds to show entire route
              //   this.playbackmap.fitBounds(L.latLngBounds(processedPoints), {
              //     padding: [50, 50]
              //   });

              //   this.showLdr = false;

              //   // Start playback with the first point
              //   this.index = 0;
              // Build a smoothed display polyline for the whole path (parking icons remain unchanged)
              try {
                const rawCoords = this.points.map((p) => ({
                  lat: p.lat,
                  lng: p.lng,
                }));
                const smoothCoords = this.bezierSmooth(rawCoords);
                if (this.route_PolylineSmooth) {
                  this.playbackmap.removeLayer(this.route_PolylineSmooth);
                }
                this.route_PolylineSmooth = L.polyline(smoothCoords, {
                  color: "#0088cc",
                  weight: 2,
                  opacity: 0.4,
                  smoothFactor: 2.5,
                  lineJoin: "round",
                }).addTo(this.playbackmap);
                if (smoothCoords && smoothCoords.length > 1) {
                  this.playbackmap.fitBounds(
                    this.route_PolylineSmooth.getBounds(),
                    { padding: [40, 40] }
                  );
                }
              } catch (e) {
                console.warn("Smooth polyline build failed", e);
              }

              this.timerId = this.update();

              // }).catch(error => {
              //   console.error('Error processing route:', error);
              //   this.showLdr = false;
              // });
            } else {
              console.log("No Vehicle Operated");
            }
            // })
            // .error(function(status, data) {
            //     console.log('Not Successfully' + data);
            // });
            // var duration = performance.now() - startTime;
            // // console.log('performance of trackvehicle() for playaback ' + duration);\
            // }
          },
          (err) => {
            // this.forgotForm['captcha'] = '';
            // this.loader = false;
            // this.errmsg = true;
            // this.err_msg = "Something went wrong. Please contact the administrator.";
          }
        );
      } else {
        this.showLdr = false;
        this.createMessage("Warning", "Please check the details");
      }
    } else {
      this.createMessage(
        "Warning",
        "Playback data only available for last 3 months"
      );
    }
  };

  // Calculate playback speed multiplier based on slider value
  calculateSpeedMultiplier(): number {
    // Map slider values to speed multipliers
    if (this.sliderValue <= 100) return 0.5;
    if (this.sliderValue <= 150) return 1.0;
    if (this.sliderValue <= 200) return 2.0;
    return 3.0; // 250 = 3x
  }

  // Handle speed change from slider
  onSpeedChange(value: number): void {
    this.sliderValue = value;
    // If currently playing, update the speed immediately
    if (this.pauseVal) {
      clearTimeout(this.timerId);
      this.timerId = this.update();
    }
    // Force change detection to update the UI
    this.ref.detectChanges();
  }
  // }

  update() {
    // If paused, don't continue the animation
    if (!this.pauseVal) {
      return undefined; // audit obs #10 (ng19/TS5.8 noImplicitReturns): update() returns the timer id on the active path, so void paths must return explicitly
    }

    // Calculate current speed multiplier
    const speedMultiplier = this.calculateSpeedMultiplier();

    // Base delay of 100ms at 1x speed
    const baseDelay = 100;
    this.speedval = Math.round(baseDelay / speedMultiplier);

    // End playback if no more points
    if (!this.points || this.points.length === 0) {
      try {
        this.message.success("TRIP COMPLETED", { nzDuration: 2000 });
        this.playbackCompleted = true;
      } catch {}
      return undefined;
    } else {
      this.playbackCompleted = false;
    }

    // if (!this.collectedParkingPoints) this.collectedParkingPoints = [];
    return setTimeout(() => {
      // If paused during timeout, don't proceed
      if (!this.pauseVal) {
        return;
      }

      this.pauseindex = this.index;

      // Get next point
      const nextPoint = this.points.shift();

      // Check for large gaps (> 0.2 km) that need road alignment
      if (this.marker) {
        const prevPos = this.marker.getLatLng();
        const distance = this.playbackmap.distance(
          prevPos,
          L.latLng(nextPoint.lat, nextPoint.lng)
        );

        // If gap > 200m, add intermediate points for smoother transition
        if (distance > 200) {
          // Store the current point for later processing
          const currentPoint = nextPoint;

          // Generate interpolated points along the road
          this.interpolateAndAddPoints(prevPos, currentPoint);

          // Skip this point as we'll process it through interpolation
          this.timerId = this.update();
          return; // audit obs #10: setTimeout callback return value is unused; keep it consistently void
        }
      }

      // Draw the next point
      this.redraw(nextPoint);

      // Continue the loop
      this.timerId = this.update();
    }, this.speedval);
  }
  // Interpolate points between two positions and add them to the playback queue
  async interpolateAndAddPoints(prevPos: L.LatLng, nextPoint: any) {
    try {
      // Generate road-aligned interpolated points with 5m spacing
      const interpolatedPoints = await generateRoadAlignedPath(
        { lat: prevPos.lat, lng: prevPos.lng },
        { lat: nextPoint.lat, lng: nextPoint.lng },
        50 // 50 meter spacing between points
      );

      if (interpolatedPoints.length > 0) {
        // Create intermediate points with the same properties as the next point
        const intermediatePoints = interpolatedPoints.map((p) => ({
          ...nextPoint,
          lat: p.lat,
          lng: p.lng,
          isInterpolated: true, // Mark as interpolated
        }));

        // Add these points to the beginning of the queue
        this.points = [...intermediatePoints, ...this.points];
      }
    } catch (error) {
      console.error("Failed to interpolate points:", error);
    }
  }

  redraw(point) {
    this.fnlParkingPoints = []; // Always reset before adding new data

    // Skip drawing parking icons for interpolated points
    const isInterpolated = !!(point && point.isInterpolated);
    let segmentMeters: number | null = null;

    if (
      typeof point?.lat === "number" &&
      typeof point?.lng === "number" &&
      this.playbackmap
    ) {
      const currentLatLng = L.latLng(point.lat, point.lng);
      if (this.lastPlottedLatLng) {
        segmentMeters = this.playbackmap.distance(
          this.lastPlottedLatLng,
          currentLatLng
        );
        if (isFinite(segmentMeters)) {
          this.cumulativeDistanceMeters += segmentMeters;
          this.travelDist =
            (this.cumulativeDistanceMeters / 1000).toFixed(2) + " Kms";
        }
      } else {
        this.travelDist = "0 Kms";
      }
      this.lastPlottedLatLng = currentLatLng;
      this.triggerSummaryRender();
    }

    let segmentTimeMs: number | null = null;

    // Timestamp: anchor to Signal when present, otherwise advance a playback clock between real points
    if (point?.Signal) {
      try {
        const m = (moment as any)(point.Signal, "DD-MM-YYYY HH:mm");
        if (m && m.isValid && m.isValid()) {
          const newTimeMs = m.valueOf();
          if (this.currentPlaybackTimeMs != null) {
            segmentTimeMs = Math.abs(newTimeMs - this.currentPlaybackTimeMs);
          }
          this.currentPlaybackTimeMs = newTimeMs;
          this.trackVehicleTimestamp = point.Signal;
          this.actualTimeDisplay = this.trackVehicleTimestamp;
        } else {
          this.trackVehicleTimestamp = point.Signal;
          this.actualTimeDisplay = this.trackVehicleTimestamp;
        }
        this.triggerSummaryRender();
      } catch {
        this.trackVehicleTimestamp = point.Signal;
        this.actualTimeDisplay = this.trackVehicleTimestamp;
        this.triggerSummaryRender();
      }
    } else if (this.currentPlaybackTimeMs != null) {
      const increment = this.speedval || 100;
      this.currentPlaybackTimeMs += increment;
      segmentTimeMs = increment;
      try {
        const d = new Date(this.currentPlaybackTimeMs);
        this.trackVehicleTimestamp = this.datepipe.transform(
          d,
          "dd-MM-yyyy HH:mm"
        );
        this.actualTimeDisplay = this.trackVehicleTimestamp;
        this.triggerSummaryRender();
      } catch {}
    }

    if (segmentTimeMs != null && segmentTimeMs > 0) {
      this.lastSegmentDurationMs = segmentTimeMs;
    }

    const durationForSpeed =
      segmentTimeMs && segmentTimeMs > 0
        ? segmentTimeMs
        : this.lastSegmentDurationMs && this.lastSegmentDurationMs > 0
        ? this.lastSegmentDurationMs
        : null;

    // Speed: prefer actual speed_ct. If missing (e.g., on interpolated frames), compute from movement and fall back to last known
    if (typeof point?.speed_ct === "number" && !isNaN(point.speed_ct)) {
      this.lastKnownSpeedCt = point.speed_ct;
      this.trackVehicleSpeed = point.speed_ct + " Kms";
      this.triggerSummaryRender();
    } else if (segmentMeters != null && durationForSpeed) {
      const kmh = (segmentMeters / durationForSpeed) * 3600;
      if (isFinite(kmh)) {
        this.lastKnownSpeedCt = kmh;
        this.trackVehicleSpeed = kmh.toFixed(1) + " Kms";
        this.triggerSummaryRender();
      }
    } else if (this.lastKnownSpeedCt !== null) {
      this.trackVehicleSpeed = this.lastKnownSpeedCt + " Kms";
      this.triggerSummaryRender();
    }

    if (
      this.currentPlaybackTimeMs != null &&
      this.playbackStartTimeMs == null
    ) {
      this.playbackStartTimeMs = this.currentPlaybackTimeMs;
    }
    if (
      this.playbackStartTimeMs != null &&
      this.currentPlaybackTimeMs != null
    ) {
      const elapsedMs = Math.max(
        0,
        this.currentPlaybackTimeMs - this.playbackStartTimeMs
      );
      this.totalTravelTime = moment.utc(elapsedMs).format("HH:mm:ss");
      this.actualTimeDisplay = this.trackVehicleTimestamp;
      this.triggerSummaryRender();
    }

    // Only show stoppage markers for non-interpolated points with valid stoppage time (> 0)
    if (
      !isInterpolated &&
      point.stoppageTime !== undefined &&
      point.stoppageTime > 0
    ) {
      // Calculate parking number ONLY when we're actually adding a marker
      // Use point.Sno if it exists and is valid, otherwise use sequential counter
      const parkingNumber = this.finalSpdMrkrs.length + 1;

      // Determine color based on stoppage time: Red for >=10 mins, Purple for <10 mins
      const markerColor = point.stoppageTime >= 10 ? "#dc3545" : "#6f42c1";

      // Create custom square marker with DivIcon
      var customParkingIcon = L.divIcon({
        className: "custom-parking-marker",
        html: `<div style="
          background-color: ${markerColor};
          color: white;
          width: 25px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid ${markerColor};
          border-radius: 4px;
          font-weight: bold;
          font-size: 10px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.3);
          font-family: Arial, sans-serif;
        ">P${parkingNumber}</div>`,
        iconSize: [25, 25],
        iconAnchor: [12, 12],
        popupAnchor: [0, -12],
      });

      // Add the marker with data
      this.finalSpdMrkrs.push(
        L.marker([point.lat, point.lng], {
          icon: customParkingIcon,
          data: {
            sno: parkingNumber,
            Sno: parkingNumber,
            asrt_nm: point.asrt_nm,
            Signal: point.Signal,
            lastTime: point.lastTime,
            stoppageTime: point.stoppageTime,
            lat: point.lat,
            lng: point.lng,
          },
        })
          .bindPopup(
            "<b>Vehicle No : " +
              point.asrt_nm +
              "<br>Parking No : P" +
              parkingNumber +
              "<br>From : " +
              point.Signal +
              "<br>To :  " +
              point.lastTime +
              "<br>STOPPAGE : " +
              point.stoppageTime +
              " Mins" +
              "</b>"
          )
          .addTo(this.playbackmap)
      );
      console.log(
        "Added parking marker P" + parkingNumber,
        this.finalSpdMrkrs.length
      );
    }
    this.fnlParkingPoints = [];
    if (this.finalSpdMrkrs.length > 0) {
      this.shwprkng = true;
      // Ensure all markers have correct sequential sno
      this.finalSpdMrkrs.forEach((marker, index) => {
        // The sno should already be set correctly from when we created the marker
        // But ensure consistency
        const correctSno = index + 1;
        if (marker.options.data) {
          marker.options.data.sno = correctSno;
          marker.options.data.Sno = correctSno;
        }
      });
    } else {
      this.shwprkng = false;
    }
    this.fnlParkingPoints = this.finalSpdMrkrs.map((mrkr) => mrkr.options.data);

    var asrtIcon = new L.Icon({
      // iconUrl: iconBase + 'plybckRngVeh.png',
      iconUrl: "/assets/images/markers/playback/startPoint2.png",
      iconSize: [41, 25],
      iconAnchor: [22, 25],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    // var asrtIcon = new L.Icon({
    //     iconUrl: 'http://localhost:4801/client/public/assets/images/markers/mapIcons/m/' +this.plybckIcn+ '_r_m.png',
    //     iconSize: [35, null],
    //     iconAnchor: [18, 10],
    //     popupAnchor: [1, -34],
    //     shadowSize: [41, 41]
    // });
    //    console.log(point);
    //    console.log(point.drcn_ct);

    //  console.log("In markerrr");

    // Store previous marker position and direction before removing it
    let prevLatLng = null;
    let prevDirection = null;

    if (this.marker) {
      prevLatLng = this.marker.getLatLng();
      // Get the current rotation angle of the marker
      prevDirection = this.marker._rotationAngle || 0;

      // Check if this is a signal jump (large distance between points)
      const distance = prevLatLng
        ? this.playbackmap.distance(prevLatLng, L.latLng(point.lat, point.lng))
        : 0;

      // If distance is significant (more than 300 meters), ensure smooth animation
      if (distance > 300) {
        // For signal jumps, we'll create a smoother animation effect
        // Get the current marker element
        const markerElement = this.marker._icon;

        if (markerElement) {
          // Add a smooth CSS transition for both position and rotation
          // Using cubic-bezier for natural easing (slow start, fast middle, slow end)
          markerElement.style.transition =
            "all 1.8s cubic-bezier(0.25, 0.1, 0.25, 1)";
        }

        // Update the marker position without removing it first
        this.marker.setLatLng(point);

        // Update the rotation angle using turf.bearing when available
        const prev = prevLatLng ? [prevLatLng.lng, prevLatLng.lat] : null;
        const curr = [point.lng, point.lat];
        let bearing =
          typeof point.drcn_ct === "number"
            ? point.drcn_ct
            : this.lastDirectionAngle;
        try {
          if (prev) bearing = turf.bearing(prev as any, curr as any);
        } catch {}
        // Apply +270 offset to match icon art orientation
        this.marker.setRotationAngle(bearing);
        this.lastDirectionAngle = bearing;

        // Add the point to the polyline
        this.line.addLatLng(point);

        // After the transition is complete, continue with normal flow
        // setTimeout(() => {
        //   // Nothing to do here, just ensuring the transition completes
        // }, 1800);

        // Return early to prevent marker removal
        return;
      }

      // For normal movement (not a signal jump), remove and recreate the marker
      this.playbackmap.removeLayer(this.marker);
    }

    // Create new marker with proper direction
    this.marker = L.marker(point, {
      icon: asrtIcon,
    }).addTo(this.playbackmap);

    // Compute direction using turf.bearing (fallback to drcn_ct or lastDirectionAngle)
    let initBearing =
      typeof (point as any).drcn_ct === "number"
        ? (point as any).drcn_ct
        : this.lastDirectionAngle;
    try {
      if (prevLatLng) {
        const prev = [prevLatLng.lng, prevLatLng.lat];
        const curr = [point.lng, point.lat];
        initBearing = turf.bearing(prev as any, curr as any);
      }
    } catch {}
    this.marker.setRotationAngle(initBearing);
    this.lastDirectionAngle = initBearing;

    // Add the new point to the polyline
    this.line.addLatLng(point);

    // If we have a previous position, animate the marker movement
    if (prevLatLng) {
      // Use CSS transitions for smooth movement
      const markerElement = this.marker._icon;
      if (markerElement) {
        // Add transition CSS if not already set by signal jump detection
        if (!markerElement.style.transition) {
          markerElement.style.transition = "transform 0.5s ease-in-out";
        }
      }
    }

    // Set the new position
    this.marker.setLatLng(point);
    // console.log(this.line);

    // console.log(this.marker);
    // this.marker.setRotationAngle(point.drcn_ct + 90);

    this.index++;

    //----------fitBounds -- Leaflet OS Playback----------//
    // this.playbackmap.fitBounds(bounds);
    //----------panTo -- Leaflet OS Playback----------//
    // Smoothly center the map on the vehicle with animation
    this.playbackmap.setView(point, this.playbackmap.getZoom(), {
      animate: true,
      duration: 0.8, // Match the marker transition duration
      easeLinearity: 0.5,
    });

    //----------Fence End Area (flag position) -- Leaflet OS Playback----------//

    try {
      if (this.points.length == 0) {
        this.playbackCompleted = true;
        this.message.success("TRIP COMPLETED", {
          nzDuration: 2000,
        });
      } else {
        this.playbackCompleted = false;
      }
    } catch (e) {
      console.log(e);
    }

    // this.checkTripCompleted(point.lat, point.lng);
  }
  //----------Check Trips, And -- Leaflet OS Playback----------//
  // checkTripCompleted(lat, lon) {
  //     // console.log(lat, lon);
  //   try {
  //     if (lat == this.pbMarkerEndPosition.lat && lon == this.pbMarkerEndPosition.lng) {
  //       console.log("In trrrrrrrrrrrrrrp");
  //       // console.log(lat == this.pbMarkerEndPosition.lat && lon == this.pbMarkerEndPosition.lng);
  //       // $timeout(function() {
  //       //     swal("TRIP COMPLETED");
  //       //     this.isTripCompleted = true;
  //       //     this.isDisabled = true; //false
  //       // }, 100);
  //       setTimeout(() => {
  //         this.createMessage('success', 'TRIP COMPLETED');
  //       }, 100);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  //----------Clear Button -- Leaflet OS Playback----------//
  clearMarkersonMap() {
    for (var k = 0; k < this.finalSpdMrkrs.length; k++) {
      this.playbackmap.removeLayer(this.finalSpdMrkrs[k]);
      if (this.finalSpdMrkrs[k].options && this.finalSpdMrkrs[k].options.data) {
        this.finalSpdMrkrs[k].options.data = null;
      }
    }
    this.finalSpdMrkrs = [];
    this.fnlParkingPoints = [];
    this.shwprkng = false;
    // this.isTripCompleted = true;
    // this.isDisabled = false;
    this.points = [];
    for (var k = 0; k < this.Route_collectPointArray.length; k++) {
      this.playbackmap.removeLayer(this.Route_collectPointArray[k]);
    }
    for (var k = 0; k < this.Route_collectPointArray1.length; k++) {
      this.playbackmap.removeLayer(this.Route_collectPointArray1[k]);
    }
    clearTimeout(this.timerId);
    if (this.marker) {
      this.playbackmap.removeLayer(this.marker);
    }
    if (this.line) {
      this.playbackmap.removeLayer(this.line);
    }
    if (this.startPBMarker) {
      this.playbackmap.removeLayer(this.startPBMarker);
    }
    if (this.endPBMarker) {
      this.playbackmap.removeLayer(this.endPBMarker);
    }
    if (this.route_Polyline) {
      this.playbackmap.removeLayer(this.route_Polyline);
    }
    if (this.route_PolylineSmooth) {
      this.playbackmap.removeLayer(this.route_PolylineSmooth);
      this.route_PolylineSmooth = null;
    }
    // if (this.route_Polyline) {
    //     $rootScope.playbackmap.removeLayer(route_Polyline);
    // }
    // if (measurePolyline) {
    //     $rootScope.playbackmap.remove(measurePolyline);
    // }
    // if (scaleHeight) {
    //     $rootScope.playbackmap.remove(scaleHeight);
    // }
  }

  private resetSpeedControlsToDefault(): void {
    if (this.sliderValue !== 100) {
      this.sliderValue = 100;
      try {
        this.ref.detectChanges();
      } catch {}
    }
  }

  private primePlaybackRuntimeMetrics(): void {
    this.cumulativeDistanceMeters = 0;
    this.lastPlottedLatLng = null;
    this.playbackStartTimeMs = null;
    this.currentPlaybackTimeMs = null;
    this.lastSegmentDurationMs = null;
    this.trackVehicleSpeed = "--";
    this.trackVehicleTimestamp = "--";
    this.actualTimeDisplay = "--";
    this.totalTravelTime = "00:00:00";
    this.travelDist = "0 Kms";
    this.triggerSummaryRender();
  }

  private resetTripSummary(clearDriver: boolean = true): void {
    this.trackVehicleTimestamp = "--";
    this.actualTimeDisplay = "--";
    this.trackVehicleSpeed = "--";
    this.totalTravelTime = "--";
    this.travelDist = "--";
    if (clearDriver) {
      this.drvr_nm = "--";
      this.drvr_mbl_nu = "--";
    }
    this.cumulativeDistanceMeters = 0;
    this.lastPlottedLatLng = null;
    this.playbackStartTimeMs = null;
    this.currentPlaybackTimeMs = null;
    this.lastSegmentDurationMs = null;
    this.triggerSummaryRender();
  }

  private handleVehicleChangeCleanup(): void {
    this.resetTripSummary();
    this.shwSpdMtr = false;
    this.showSpeedControl = false;
    this.trpDta = [];
    this.rtplydata = null;
    this.pauseVal = true;
    this.resetSpeedControlsToDefault();
    this.fnlParkingPoints = [];
    this.shwprkng = false;
    this.points = [];
    this.lastSegmentDurationMs = null;
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    if (this.plyBckform) {
      this.plyBckform.patchValue(
        {
          plybtype: null,
          trpdt: null,
          trp: null,
          strtTm: null,
          endTm: null,
        },
        { emitEvent: false }
      );
    }
    this.trpdate = false;
    this.trpdtl = false;
    this.strtdate = false;
    this.enddate = false;
  }

  private triggerSummaryRender(): void {
    try {
      this.ref.detectChanges();
    } catch {}
  }

  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }

  getTripData(trpId) {
    if (trpId) {
      // if (this.plypoint) {
      //   for (var k = 0; k < this.plypoint.length; k++) {
      //     this.playbackmap.removeLayer(this.plypoint[k].ply);

      //   }

      // }
      this.getCheckedItemList();
      console.log(trpId);
      for (var l = 0; l < this.trpDta.length; l++) {
        if (trpId == this.trpDta[l].trp_rn_id) {
          // console.log('valliiiiiiiiiiiiiiii')
          this.drvr_nm = this.trpDta[l].drvr_nm;
          this.drvr_mbl_nu = this.trpDta[l].drvr_phne_nu;
          this.rtplydata = this.trpDta[l].rte_arc_lne_tx;
          this.sdate = this.trpDta[l].actl_strt_ts;
          this.edate = this.trpDta[l].actl_end_ts;
          this.plyBckform.get("strtTm").setValue(this.sdate);
          this.plyBckform.get("endTm").setValue(this.edate);
          this.plyBckform.value.strtTm = this.sdate;
          this.plyBckform.value.endTm = this.edate;
          // if (this.trpDta[l].fnce_arc_lne_tx) {
          //   this.fncepolygon = L.polygon(JSON.parse(this.locations[l].fnce_arc_lne_tx) as []
          //     , { color: this.locations[l].fncs_clr_cd }).addTo(this.playbackmap).bindTooltip(this.locations[l].fnce_nm, { permanent: true, opacity: 0.7 }).openTooltip();
          //   this.plypoint1.push({ ply: this.fncepolygon, fnce_id: this.locations[l].fnce_id });
          //   this.playbackmap.fitBounds(this.fncepolygon.getBounds());
          // }
        }
      }
      var trpobj = {
        trprnid: trpId,
      };

      if (this.rtplydata == null) {
        this.cntxt.length = 0;
        // this.masterSelected = false;
      } else {
        // console.log('hiiiiiiiiii')
        this.apiS.post(trpobj, "playback/cntxtPlgns").subscribe(
          (res) => {
            console.log(res["data"]);
            this.cntxt = res["data"];
            // console.log(this.cntxt);

            for (var k = 0; k < res["data"].length; k++) {
              this.checklist.push({
                id: res["data"][k].fnce_id,
                value: res["data"][k].fnce_nm,
                plyline: res["data"][k].fnce_arc_lne_tx,
                fncs_clr_cd: res["data"][k].fncs_clr_cd,
                isSelected: true,
              });
            }
            // this.masterSelected = true;

            this.getCheckedItemList();

            // for (var i = 0; i < this.cntxt.length; i++) {

            //   if (this.cntxt[i].fnce_arc_lne_tx) {

            //     this.polygon = L.polygon(JSON.parse(this.cntxt[i].fnce_arc_lne_tx) as []
            //       , { color: this.cntxt[i].fncs_clr_cd }).addTo(this.playbackmap).bindTooltip(this.cntxt[i].fnce_nm, { permanent: true, opacity: 0.7 }).openTooltip();
            //       this.playbackmap.fitBounds(this.polygon.getBounds());

            //   }

            // if(this.cntxt[0].fnce_arc_lne_tx){

            // }
            // }
            // console.log(this.checklist);
          },
          (err) => {
            console.log("In errorr");
          }
        );

        // this.sdate= this.datepipe.transform(this.sdate, 'yyyy-MM-dd 00:00'),
        // this.edate= this.datepipe.transform(this.edate, 'yyyy-MM-dd 23:59')

        // console.sdate);
        // }

        //  console.log(this.rtplydata);
        //  if(this.rtplydata){

        // this.route_Polyline = L.polyline(this.rtplydata, {
        //    color: '#008000',
        //   weight: 5,
        //   lineCap: 'butt',
        //   opacity: 0.5,
        //   smoothFactor: 10.0,
        //   lineJoin: 'round'
        // }).addTo(this.playbackmap);
        // }
        // this.playPolygonData = [{
        //   mcrpt_id: 1,
        //   mcrpt_nm: 'MP-1',
        //   plgn_area: [[17.000045, 81.798557], [17.001451, 81.802967], [17.001985, 81.807849],
        //   [16.999133, 81.801809], [17.000045, 81.798557]]
        // },
        // {
        //   mcrpt_id: 2,
        //   mcrpt_nm: 'MP-2',
        //   plgn_area: [[17.000045, 81.798557], [17.001481, 81.802987], [17.002005, 81.807849],
        //   [16.999313, 81.802309], [17.002045, 81.798550], [17.000045, 81.798557]]
        // },
        // {
        //   mcrpt_id: 3,
        //   mcrpt_nm: 'MP-3',
        //   plgn_area: [[17.001461, 81.802967], [17.001785, 81.807859],
        //   [16.990133, 81.801819], [17.000145, 81.798857], [17.002345, 81.745857], [17.006845, 81.797957], [17.001461, 81.802967]]
        // }]
      }
    }
  }

  // chckFun(slctd) {
  //   console.log(slctd)
  //   if (slctd == true) {
  //     if (slctd.fnce_arc_lne_tx) {

  //       this.polygon = L.polygon(JSON.parse(slctd.fnce_arc_lne_tx) as []
  //         , { color: slctd.fncs_clr_cd }).addTo(this.playbackmap).bindTooltip(slctd.fnce_nm, { permanent: true, opacity: 0.7 }).openTooltip();

  //     }
  //   } else if (slctd == false) {
  //     this.playbackmap.removeLayer(this.polygon);
  //   }
  // }

  // updateAllChecked(plyVal): void {
  //   console.log(this.allChecked);
  //   this.indeterminate = false;
  //   if (this.allChecked) {
  //     this.cntxt = this.cntxt.map(item => {
  //       console.log(item);
  //       for (var i = 0; i < this.cntxt.length; i++) {
  //         if (this.cntxt[i].fnce_arc_lne_tx) {
  //           this.polygon = L.polygon(JSON.parse(this.cntxt[i].fnce_arc_lne_tx) as []
  //             , { color: this.cntxt[i].fncs_clr_cd }).addTo(this.playbackmap).bindTooltip(this.cntxt[i].fnce_nm, { permanent: true, opacity: 0.7 }).openTooltip();
  //         }
  //       }
  //       this.playbackmap.fitBounds(this.polygon.getBounds());
  //       return {
  //         ...item,
  //         checked: true
  //       };
  //     });
  //   } else {
  //     this.playbackmap.removeLayer(this.polygon);

  //     this.cntxt = this.cntxt.map(item => {
  //       console.log(item);
  //       return {
  //         ...item,
  //         checked: false

  //       };
  //     });
  //   }
  // }

  // updateSingleChecked(plyVal): void {

  //   this.cntxt = this.cntxt.map(item => {
  //     console.log(item);

  //   });
  //   if (this.cntxt.every(item => !item.checked)) {
  //     // console.log(item.checked);
  //     console.log(this.cntxt.every(item => !item.checked));
  //     // console.log(item);
  //     this.allChecked = false;
  //     this.indeterminate = false;
  //     // this.cntxt.map(item => {
  //     //   console.log(item);
  //     // });
  //   } else if (this.cntxt.every(item => item.checked)) {
  //     console.log(this.cntxt.every(item => item.checked));
  //     this.allChecked = true;
  //     this.indeterminate = false;
  //     // this.cntxt.map(item => {
  //     //   console.log(item);
  //     // });
  //   } else {
  //     // console.log(item);
  //     this.indeterminate = true;
  //   }
  // }

  // this.checklist = [
  //   {id:1,value:'Elenor Anderson',isSelected:false},
  //   {id:2,value:'Caden Kunze',isSelected:true},
  //   {id:3,value:'Ms. Hortense Zulauf',isSelected:true},
  //   {id:4,value:'Grady Reichert',isSelected:false},
  //   {id:5,value:'Dejon Olson',isSelected:false},
  //   {id:6,value:'Jamir Pfannerstill',isSelected:false},
  //   {id:7,value:'Aracely Renner DVM',isSelected:false},
  //   {id:8,value:'Genoveva Luettgen',isSelected:false}
  // ];

  // }

  checkUncheckAll() {
    console.log("un heck all");
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }
  isAllSelected() {
    console.log("check all");
    // this.checklist=[];
    this.masterSelected = this.checklist.every(function (item: any) {
      console.log(item);
      // this.checklist.push(item);
      // if(item.isSelected == false){
      //   for (var k = 0; k < this.plypoint.length; k++) {
      //     this.playbackmap.removeLayer(this.plypoint[k]);

      //   }
      // }
      // this.slctdItm = item;
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }

  getPlybackType(value) {
    console.log(value);
    this.plyBckform.get("endTm").setValue("");
    this.plyBckform.get("strtTm").setValue("");
    // this.plyBckform.get('vhcl').setValue('');
    // this.plyBckform.get('trpdt').setValue('');
    this.clearMarkersonMap();
    this.trpdate = false;
    this.strtdate = false;
    this.enddate = false;
    this.trpdtl = false;
    this.vehdetails = false;
    if (value == 1) {
      this.trpdate = true;
      this.strtdate = true;
      this.enddate = true;
      this.trpdtl = true;
      this.vehdetails = true;
      this.removeAllSchedPlyline();
    } else {
      this.plyBckform
        .get("strtTm")
        .setValue(this.datepipe.transform(this.date, "yyyy-MM-dd 00:00"));
      this.plyBckform
        .get("endTm")
        .setValue(this.datepipe.transform(this.date, "yyyy-MM-dd 23:59"));

      this.trpdate = false;
      this.trpdtl = false;
      this.strtdate = true;
      this.enddate = true;
      this.vehdetails = true;
      this.removeAllSchedPlyline();
      if (this.clntDtls[0].clnt_id == 3000001) {
        this.getscheduledRoutes();
      }
    }
  }

  getCheckedItemList() {
    console.log(this.masterSelected);
    console.log(this.checklist);
    // this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected == true) {
        console.log("in true");
        if (this.plypoint) {
          for (var k = 0; k < this.plypoint.length; k++) {
            if (this.checklist[i].id == this.plypoint[k].fnce_id) {
              this.playbackmap.removeLayer(this.plypoint[k].ply);
            }
          }
        }
        if (this.checklist[i].plyline) {
          this.polygon = L.polygon(
            JSON.parse(this.checklist[i].plyline) as [],
            { color: this.checklist[i].fncs_clr_cd }
          )
            .addTo(this.playbackmap)
            .bindTooltip(this.checklist[i].value, {
              permanent: true,
              opacity: 0.7,
            })
            .openTooltip();
          this.plypoint.push({
            ply: this.polygon,
            fnce_id: this.checklist[i].id,
          });
          this.playbackmap.fitBounds(this.polygon.getBounds());
        }
      }
      console.log(this.plypoint);
      if (this.checklist[i].isSelected == false) {
        if (this.plypoint) {
          for (var k = 0; k < this.plypoint.length; k++) {
            if (this.checklist[i].id == this.plypoint[k].fnce_id) {
              this.playbackmap.removeLayer(this.plypoint[k].ply);
            }
          }
        }
      }
      // console.log(this.polygon);

      // else{
      // console.log(this.polygon)
      // if(this.polygon){
      // this.playbackmap.removeLayer(this.polygon[i]);
      // }
      // }

      // this.checkedList.push(this.checklist[i]);
      // this.playbackmap.removeLayer(this.polygon);
    }

    // this.checkedList = JSON.stringify(this.checkedList);
    // console.log(this.slctdItm);
    // console.log(this.checkedList.length);
    // if (this.checkedList.length!=0) {
    // console.log("hhhhhhhhh")

    // for (var i = 0; i < this.checkedList.length; i++) {
    //   if (this.checkedList[i].fnce_arc_lne_tx) {

    //     }

    // }
  }
  closedrvrlst() {
    this.opnSdebar = false;
    this.playbackmap.invalidateSize();
  }
  getscheduledRoutes() {
    this.apiS.get(`playback/vehicle/scheduledRoutes/${this.asrt_id}`).subscribe(
      (res) => {
        console.log(res["data"]);
        this.schdRtsLst = res["data"];
        if (this.schdRtsLst && this.schdRtsLst.length > 0) {
          if (this.route_Polyline) {
            this.playbackmap.removeLayer(this.route_Polyline);
          }
          this.route_Polyline2 = [];
          this.removeAllSchedPlyline();
          for (var i = 0; i < this.schdRtsLst.length; i++) {
            if (this.schdRtsLst[i].rte_arc_lne_tx) {
              this.route_Polyline2.push(
                L.polyline(JSON.parse(this.schdRtsLst[i].rte_arc_lne_tx), {
                  color: "#008000",
                  weight: 5,
                  lineCap: "butt",
                  opacity: 0.5,
                  smoothFactor: 10.0,
                  lineJoin: "round",
                }).addTo(this.playbackmap)
              );
            }
          }
        }
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }
  removeAllSchedPlyline() {
    if (this.route_Polyline && this.route_Polyline.length > 0) {
      for (var i = 0; i < this.route_Polyline.length; i++) {
        this.playbackmap.removeLayer(this.route_Polyline[i]);
      }
    }
    if (this.route_Polyline2 && this.route_Polyline2.length > 0) {
      for (var i = 0; i < this.route_Polyline2.length; i++) {
        this.playbackmap.removeLayer(this.route_Polyline2[i]);
      }
    }
  }
  getAssrtGroupLists(grpId: any) {
    console.log(grpId);
    if (this.clap_in == 1 && this.clntDtls[0].clnt_id == 3000001) {
      this.asrt_grp_id = grpId;
      this.getVhcles();
      return;
    } else {
      this.asrt_grp_id = 0;
    }
  }

  // Smooth only moving segments (speed > 0) while preserving parking anchors
  smoothPlaybackPoints(points: any[]): any[] {
    if (!points || points.length < 3) return points;
    const result: any[] = [];

    const isParking = (p: any) =>
      p &&
      ((p.stoppageTime !== undefined && p.stoppageTime > 0) ||
        p.speed_ct === 0);

    // Indices of anchors (parking or endpoints)
    const anchors: number[] = [];
    for (let i = 0; i < points.length; i++) {
      if (isParking(points[i])) anchors.push(i);
    }
    if (anchors[0] !== 0) anchors.unshift(0);
    if (anchors[anchors.length - 1] !== points.length - 1)
      anchors.push(points.length - 1);

    for (let a = 0; a < anchors.length - 1; a++) {
      const startIdx = anchors[a];
      const endIdx = anchors[a + 1];
      const segment = points.slice(startIdx, endIdx + 1);

      // If both ends are parking, keep them as hard anchors and smooth inside if there are enough points
      const start = segment[0];
      const end = segment[segment.length - 1];

      if (segment.length <= 2) {
        // Not enough to smooth
        if (result.length === 0) result.push(start);
        else if (result[result.length - 1] !== start) result.push(start);
        result.push(end);
        continue;
      }

      // Decide if this is a moving segment: any point with speed > 0
      const moving = segment.some(
        (p) =>
          p &&
          (p.speed_ct === undefined || p.speed_ct > 0) &&
          !(p.stoppageTime > 0)
      );
      if (!moving) {
        // Fully parking zone: keep as-is
        if (result.length === 0) result.push(...segment);
        else {
          // avoid duplicating the first point
          result.push(...segment.slice(1));
        }
        continue;
      }

      // Smooth inside segment while preserving ends
      const coords = segment.map((p) => ({ lat: p.lat, lng: p.lng }));
      const smoothedCoords = this.chaikinSmoothSegment(coords, 2, true);

      // Choose a seed speed for midpoints: first positive speed in segment, else start/end speed if numeric
      let seedSpeed: number | undefined = undefined;
      for (const p of segment) {
        if (
          typeof p?.speed_ct === "number" &&
          !isNaN(p.speed_ct) &&
          p.speed_ct > 0
        ) {
          seedSpeed = p.speed_ct;
          break;
        }
      }
      if (seedSpeed === undefined) {
        if (
          typeof start?.speed_ct === "number" &&
          !isNaN(start.speed_ct) &&
          start.speed_ct > 0
        )
          seedSpeed = start.speed_ct;
        else if (
          typeof end?.speed_ct === "number" &&
          !isNaN(end.speed_ct) &&
          end.speed_ct > 0
        )
          seedSpeed = end.speed_ct;
        else if (this.lastPositiveSpeedCt !== null)
          seedSpeed = this.lastPositiveSpeedCt;
      }

      // Rebuild points: keep original meta on anchors, copy key meta for midpoints
      const rebuilt: any[] = [];
      smoothedCoords.forEach((c, idx) => {
        if (idx === 0) {
          rebuilt.push(start); // preserve meta
        } else if (idx === smoothedCoords.length - 1) {
          rebuilt.push(end); // preserve meta
        } else {
          rebuilt.push({
            lat: c.lat,
            lng: c.lng,
            // carry a positive speed so redraw shows consistent speed through moving segments
            speed_ct: seedSpeed !== undefined ? seedSpeed : undefined,
            asrt_nm: start.asrt_nm,
            // mark as interpolated so stoppage markers don't render on these
            isInterpolated: true,
          });
        }
      });

      if (result.length === 0) result.push(...rebuilt);
      else {
        // avoid duplicating the first point
        result.push(...rebuilt.slice(1));
      }
    }

    return result;
  }

  // Chaikin corner-cutting smoothing with optional end preservation
  chaikinSmoothSegment(
    points: { lat: number; lng: number }[],
    iterations = 2,
    keepEnds = true
  ): { lat: number; lng: number }[] {
    if (!points || points.length < 3 || iterations <= 0) return points;
    let current = points.slice();
    for (let it = 0; it < iterations; it++) {
      const next: { lat: number; lng: number }[] = [];
      const start = current[0];
      const end = current[current.length - 1];
      if (keepEnds) next.push({ ...start });
      for (let i = 0; i < current.length - 1; i++) {
        const p = current[i];
        const q = current[i + 1];
        const Q = {
          lat: 0.75 * p.lat + 0.25 * q.lat,
          lng: 0.75 * p.lng + 0.25 * q.lng,
        };
        const R = {
          lat: 0.25 * p.lat + 0.75 * q.lat,
          lng: 0.25 * p.lng + 0.75 * q.lng,
        };
        next.push(Q);
        next.push(R);
      }
      if (keepEnds) next.push({ ...end });
      current = next;
    }
    return current;
  }

  bezierSmooth(
    points: { lat: number; lng: number }[]
  ): { lat: number; lng: number }[] {
    if (!points || points.length < 2) return points;

    // Convert to Turf LineString ([lng, lat])
    const line = turf.lineString(points.map((p) => [p.lng, p.lat]));

    // Apply bezierSpline
    const curved = turf.bezierSpline(line, {
      resolution: 10000, // number of steps (higher = smoother)
      sharpness: 0.85, // adjust curve sharpness (0 → very smooth, 1 → sharper)
    });

    // Convert back to [lat, lng] for Leaflet
    return curved.geometry.coordinates.map((c: any) => ({
      lat: c[1],
      lng: c[0],
    }));
  }
  // onExporting() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.
}
